const Vendor = {

    // FIELDS
    "name": "Name",
    "business_name": "Business Name",
    "phone": "Phone",
    "email": "Email",
    "city": "City",
    "address": "Address",
    "status": "Status",
    "user_status": "User Status",
    "search": "Search",

    // PAGE HEADER
    "vendor": "Vendor",
    "service": "Services",
    "order": "Subscription",
    "booking": "Bookings",
    "customer": "Customer",
    "employee": "Employee",
    "offer": 'Offer',

    // TABLE HEADER
    "table_name": 'NAME',
    "table_image": "IMAGE",
    "table_business_name": "BUSINESS NAME",
    "table_phone": "PHONE",
    "table_email": "EMAIL",
    "table_city": "CITY",
    "table_address": "ADDRESS",
    "table_status": "STATUS",
    "table_user_status": "USER STATUS",

    // TABLE BOOKING

    "customer_list": "Customer",
    "contact": "CONTACT",
    "role": "ROLE",
    "table_employee": "EMPLOYEE",
    "table_customer": "CUSTOMER",
    "booking_allowed": "BOOKING ALLOWED",
    "table_date": "DATE",
    "time": "TIME",

    "plan": "Plan",
    "payment": "Payment",
    "transaction": "Transaction",
    "details": "Details",
    "created_at": "Created At",
    "updated_at": "Updated At",
    "order_id": "Order ID",
    "amount": "Amount",

    //TABLE ORDER
    "table_order_id": 'ORDER ID',
    // "table_customer": "CUSTOMER ",
    "table_amount": "AMOUNT",
    "table_order_status": "ORDER STATUS",
    "table_order_date": "DATE",

    // TABLE SERVICE
    "service_name": "SERVICE NAME",
    "category": "CATEGORY",
    "main_category": "MAIN CATEGORY",
    "service_type": "SERVICE",
    "price": "PRICE",
    "duration": "DURATION",

}

export default Vendor;

